/* eslint-disable */

// adding able-wrapper class to the table created by WYSIWYG


function handleTables() {
  const tables = document.querySelectorAll('.body-copy table');
  
  if (!tables.length) return;
  
  tables.forEach((table) => {
    if (table.closest('.table-wrapper')) return;

    const outerWrapper = document.createElement('div');
    outerWrapper.classList.add('table-container');

    const scrollWrapper = document.createElement('div');
    scrollWrapper.classList.add('table-wrapper');

    // Restructure the DOM
    table.parentNode.insertBefore(outerWrapper, table);
    outerWrapper.appendChild(scrollWrapper);
    scrollWrapper.appendChild(table);

    const tableCaption = table.querySelector('caption');
    if (tableCaption) {
      const captionWrapper = document.createElement('div');
      captionWrapper.classList.add('table-caption');
      captionWrapper.appendChild(tableCaption);
      outerWrapper.appendChild(captionWrapper);
    }
    
    checkTableOverflow(scrollWrapper, outerWrapper, table);
  });
}

function checkTableOverflow(scrollWrapper, outerWrapper, table) {
  const overlay = document.createElement('div');
  overlay.classList.add('table-scroll-overlay');
  
  if (scrollWrapper.scrollWidth > scrollWrapper.clientWidth) {
    outerWrapper.appendChild(overlay);
    
    const tableHeight = table.offsetHeight;
    table.parentNode.parentNode.classList.add('table-scroll');
    const overlayElement = document.querySelector('.table-scroll-overlay'); 
    if (overlayElement) {
        // overlayElement.style.height = `${tableHeight + 10}px`;
        overlayElement.style.height = `${tableHeight}px`;
    }
    
    scrollWrapper.addEventListener('scroll', () => {
      const scrollPercentage = (scrollWrapper.scrollLeft + scrollWrapper.clientWidth) / scrollWrapper.scrollWidth;
      
      if (scrollPercentage >= 0.98) {
        overlay.style.opacity = '0';
      } else {
        overlay.style.opacity = '1';
      }
    });
  }
}

window.addEventListener('DOMContentLoaded', () => handleTables());
